export default {
  title: 'Department Productivity Report',
  backButton: 'Back to all reports',
  adminBackButton: 'Back to MBD Reports',
};
